import createTusSender from "./tusSender";
import { TUS_EXT } from "./consts";

const getTusEnhancer = options => {
  //return uploader enhancer
  return (uploader, trigger) => {
    const sender = createTusSender(uploader, options, trigger);
    uploader.update({
      send: sender.send
    });
    uploader.registerExtension(TUS_EXT, {
      getOptions: sender.getOptions
    });
    return uploader;
  };
};

export default getTusEnhancer;